<template>
    <div id="app">
        <router-view :key="$route.fullPath" />
    </div>
</template>

<script>
    export default {}
</script>

<style lang="stylus"></style>
